<template>
  <div class="number-prefix">
    <form :action="formAction" method="GET">
      <input v-model="countryPhonePrefix" class="col m2 number-check-prefix number-check-prefix-margin" readonly="" style="margin-bottom: 0; background-color: #eeeeee;" type="text">
      <input class="col m6 number-check validate-phone-fonmoney number-field" name="number" placeholder="123467890" type="tel">
      <button class="col m4 number-check-btn" type="submit">
        <span class="btn-text" data-t="Charge now"> {{ t("Charge now") }} </span>
      </button>
    </form>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "topup-number",
  props: {
    countryPhonePrefix: String,
    country: String
  },
  computed: {
      formAction() {
          return "/p/topup_" + this.country.toLowerCase();
      }
  }
});
</script>